<template>
  <b-modal
    :visible="show"
    title="Criar nova senha"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    @hide="$emit('close')"
  >
    <b-form-group label="Nova senha">
      <div class="position-relative w-100">
        <b-form-input
          v-model="senha"
          :type="showSenha ? 'text' : 'password'"
          placeholder="Digite a nova senha"
        />
        <span
          class="position-absolute"
          style="
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
            cursor: pointer;
          "
          @click="showSenha = !showSenha"
        >
          <i :class="showSenha ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
    </b-form-group>

    <b-form-group label="Confirmar senha">
      <div class="position-relative w-100">
        <b-form-input
          v-model="confirmarSenha"
          :type="showConfirmarSenha ? 'text' : 'password'"
          placeholder="Confirme a nova senha"
        />
        <span
          class="position-absolute"
          style="
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
            cursor: pointer;
          "
          @click="showConfirmarSenha = !showConfirmarSenha"
        >
          <i :class="showConfirmarSenha ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
    </b-form-group>

    <div class="mb-3">
      <small class="d-block mb-1">
        Força da senha: <strong>{{ passwordStrengthLabel }}</strong>
      </small>

      <b-progress
        :value="passwordStrengthPercent"
        max="100"
        :variant="passwordStrengthVariant"
        height="8px"
      />
    </div>

    <ul class="text-left small mb-3">
      <li :class="temLetra ? 'text-success' : 'text-muted'">
        ✔ Pelo menos uma letra
      </li>
      <li :class="temNumero ? 'text-success' : 'text-muted'">
        ✔ Pelo menos um número
      </li>
      <li :class="tamanhoMinSenha ? 'text-success' : 'text-muted'">
        ✔ Mínimo de 8 caracteres
      </li>
    </ul>

    <b-button variant="primary" class="w-100" @click="submit">
      <b-spinner v-if="isLoading" small class="mr-2" />
      Atualizar senha
    </b-button>

    <p v-if="error" class="text-danger mt-2 mb-0">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
import zxcvbn from 'zxcvbn';

export default {
  name: 'ModalNovaSenha',

  props: {
    show: Boolean,
  },

  data() {
    return {
      senha: '',
      confirmarSenha: '',
      isLoading: false,
      error: null,
      showSenha: false,
      showConfirmarSenha: false,
    };
  },

  computed: {
    passwordScore() {
      if (!this.senha) return 0;
      return zxcvbn(this.senha).score;
    },

    passwordStrengthPercent() {
      return (this.passwordScore + 1) * 20;
    },

    passwordStrengthLabel() {
      const labels = ['Muito fraca', 'Fraca', 'Média', 'Boa', 'Forte'];
      return labels[this.passwordScore];
    },

    passwordStrengthVariant() {
      const variants = ['danger', 'danger', 'warning', 'info', 'success'];
      return variants[this.passwordScore];
    },

    senhasIguais() {
      return this.senha === this.confirmarSenha;
    },

    temLetra() {
      return /[a-zA-Z]/.test(this.senha);
    },

    temNumero() {
      return /\d/.test(this.senha);
    },

    tamanhoMinSenha() {
      return this.senha.length >= 8;
    },

    canSubmit() {
      return (
        this.tamanhoMinSenha &&
        this.confirmarSenha &&
        this.senhasIguais &&
        this.passwordScore >= 2 &&
        this.temLetra &&
        this.temNumero
      );
    },
  },

  methods: {
    submit() {
      this.error = null;

      if (!this.senhasIguais) {
        this.error = 'As senhas não conferem.';
        return;
      }

      if (this.passwordScore < 2) {
        this.error = 'A senha está muito fraca.';
        return;
      }

      if (!this.tamanhoMinSenha) {
        this.error = 'A senha deve ter pelo menos 8 caracteres.';
        return;
      }

      if (!this.temLetra) {
        this.error = 'A senha deve conter pelo menos uma letra.';
        return;
      }

      if (!this.temNumero) {
        this.error = 'A senha deve conter pelo menos um número.';
        return;
      }

      this.isLoading = true;

      this.$emit('submit', {
        senha: this.senha,
        onSuccess: () => {
          this.reset();
          this.$emit('success');
        },
        onError: (msg) => {
          this.error = msg || 'Não foi possível atualizar a senha.';
        },
        onFinish: () => {
          this.isLoading = false;
        },
      });
    },

    reset() {
      this.senha = '';
      this.confirmarSenha = '';
      this.error = null;
      this.isLoading = false;
      this.showSenha = false;
      this.showConfirmarSenha = false;
    },
  },
};
</script>
